module.exports = __webpack_public_path__ + "img/create_gkmg_apointment.e450e69d.svg";